import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import i18n from '../../../../../i18next';
import { Container, Row, Button, Col, Form, Input, Badge, Tooltip } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';

import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../../../utils/Constants';
import SearchButton from '../../../../common/SearchButton';
import { downloadAccountingFiles, downloadInvoice, downloadRevolutFile, downloadXeroFile, getBrandAndRestNames, getInvoiceCollection, getInvoices, getMonthlySystemStatisticDashboard, getSystemStatisticDashboard, getMonthlyPayableReconciliation, getDataBasedOnInvoiceNumberSearch } from '../../../../../actions';
import { getCurrencySymbol, transformProductPrice } from '../../../../../utils/CommonUtils';
import BillingDashboardInvoiceCollection from './BillingDashboardInvoiceCollection';

class BillingDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: {
                week: '',
                year: '',
                month: ''
            },
            monthlySearchQuery: {
                year: '',
                month: '',
                billingTypeIndex: ''
            },
            currentPageNumber: 0,
            currentInvoiceCollection: null,
            isInvoicesDashboardOpen: false,
            currentInvoiceCollectionDate: {
                week: '',
                year: ''
            },
            isWeeklyRevenue: true,
            isMonthlyRevenue: false,
            monthlyCurrentPageNumber: 0,
            currentMonthPayableReconDate: {
                month: '',
                year: ''
            },
            isInvoicesSearch: false,
            invoiceNumber: '',
            fromDate: null,
            toDate: null,
            total: null,
            invoicesCurrentPage: 0
        }

        this.search = this.search.bind(this);
        this.changeState = this.changeState.bind(this);
        this.toggleInvoicesDashboard = this.toggleInvoicesDashboard.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.onBackInvoiceCollection = this.onBackInvoiceCollection.bind(this);
        this.toggleRevenueButtons = this.toggleRevenueButtons.bind(this);
        this.handleMonthlyPageChange = this.handleMonthlyPageChange.bind(this);
        this.toggleRevolutInfoTooltip = this.toggleRevolutInfoTooltip.bind(this);
        this.handleInvoicesPageChange = this.handleInvoicesPageChange.bind(this);
    }

    componentDidMount() {
        this.props.getSystemStatisticDashboard(this.state.currentPageNumber, this.state.searchQuery);
        this.props.getBrandAndRestNames();
        this.props.getDataBasedOnInvoiceNumberSearch(this.state.invoicesCurrentPage, this.state.searchQuery, this.state.invoiceNumber);
    }

    componentDidUpdate(prevProps) {
        const { invoiceCollection, invoiceDataCollection } = this.props;
        const { currentInvoiceCollection } = this.state;

        if (invoiceCollection !== prevProps.invoiceCollection) {
            this.setState({
                currentInvoiceCollection: invoiceCollection
            })
        } else if (invoiceDataCollection !== prevProps.invoiceDataCollection) {
            this.setState({
                invoiceNumber: invoiceDataCollection
            })
        }
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    search() {
        if(this.state.isWeeklyRevenue) {

            this.props.getSystemStatisticDashboard(this.state.currentPageNumber, this.state.searchQuery);
        } else if (this.state.isMonthlyRevenue) {

            this.props.getMonthlySystemStatisticDashboard(this.state.monthlyCurrentPageNumber, this.state.monthlySearchQuery)
        } else {

            this.props.getDataBasedOnInvoiceNumberSearch(this.state.invoicesCurrentPage, this.state.searchQuery, this.state.invoiceNumber)
        }
    }

    clearSearch() {
        if(this.state.isWeeklyRevenue) {
            this.setState({
                ...this.state,
                searchQuery: {
                    week: '',
                    year: '',
                    month: ''
                },
                currentPageNumber: 0
            }, () => this.props.getSystemStatisticDashboard(this.state.currentPageNumber, this.state.searchQuery));
        } else if (this.state.isMonthlyRevenue) {
            this.setState({
                ...this.state,
                monthlySearchQuery: {
                    month: '',
                    year: '',
                    billingTypeIndex: ''
                },
                monthlyCurrentPageNumber: 0
            }, () => this.props.getMonthlySystemStatisticDashboard(this.state.monthlyCurrentPageNumber, this.state.monthlySearchQuery))
        } else {
            this.setState({
                ...this.state,
                invoiceNumber: '',
                invoicesCurrentPage: 0
            }, () => this.props.getDataBasedOnInvoiceNumberSearch(this.state.invoicesCurrentPage, this.state.searchQuery))
        }
    }

    onBackInvoiceCollection() {

        this.setState({
            ...this.state,
            currentInvoiceCollection: null,
            currentInvoiceCollectionDate: {
                week: '',
                year: ''
            },
            currentMonthPayableReconDate: {
                month: '',
                year: ''
            }
        }, () => {
            this.toggleInvoicesDashboard()
        })
    }

    removeActiveCurrencyInfo() {
        const { systemStatistic, monthlySystemStatistic } = this.props;
        const { isWeeklyRevenue, isMonthlyRevenue } = this.state;

        const content = systemStatistic.content && isWeeklyRevenue ? systemStatistic.content : monthlySystemStatistic.content && isMonthlyRevenue ? monthlySystemStatistic.content : null;

        if (content !== undefined && content !== null && content.length) {
                content.map((statistic, i) => {
                    const currencyStatisticsInfo = `currencyStatisticsInfo${i}`;
                    const statisticsInformationRow = `statisticsInformationRow${i}`;

                    const table = document.querySelector(`.${statisticsInformationRow}`)
                    const icon = table.querySelector('i');
                    const item = document.querySelector(`.${currencyStatisticsInfo}`);

                    if([...table.classList].includes('activeStatisticsInformationRow')) {
                        table.classList.remove('activeStatisticsInformationRow');
                        icon.textContent = 'add_circle';
                        item.style.display = 'none';
                        table.style.borderBottom = '1px solid rgb(222, 226, 230)';
                    }
            })
        }
    }

    handlePageChange(pageNumber) {

        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.getSystemStatisticDashboard(this.state.currentPageNumber, this.state.searchQuery));

        this.removeActiveCurrencyInfo()
    }

    handleMonthlyPageChange(pageNumber) {

        this.setState({
            monthlyCurrentPageNumber: (pageNumber - 1)
        }, () => this.props.getMonthlySystemStatisticDashboard(this.state.monthlyCurrentPageNumber, this.state.searchQuery));

        this.removeActiveCurrencyInfo()
    }

    handleInvoicesPageChange(pageNumber) {
        this.setState({
            invoicesCurrentPage: (pageNumber - 1)
        }, () => this.props.getDataBasedOnInvoiceNumberSearch(this.state.invoicesCurrentPage, this.state.searchQuery, this.state.invoiceNumber));

        this.removeActiveCurrencyInfo()
    }


    changeState = ({ target }) => {

        if(this.state.isWeeklyRevenue) {

            this.setState({
                currentPageNumber: 0,
                searchQuery: {
                    ...this.state.searchQuery,
                    [target.name]: target.value
                },
            });
        } else if (this.state.isMonthlyRevenue) {

            this.setState({
                monthlyCurrentPageNumber: 0,
                monthlySearchQuery: {
                    ...this.state.monthlySearchQuery,
                    [target.name]: target.value
                },
            });
        } else  {
            this.setState({
                invoicesCurrentPage: 0,
                invoiceNumber: target.value
            });
        }
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    toggleInvoicesDashboard() {

        let billingDashboard = document.getElementById("billingDashboard");
        let billingDashboardInvoices = document.getElementById("billingDashboardInvoices");

        if (billingDashboard.classList.value.includes("inactiveDashboard")) {
            billingDashboard.classList.remove("inactiveDashboard");
            billingDashboard.classList.add("activeDashboard");
        } else if (billingDashboard.classList.value.includes("activeDashboard")) {
            billingDashboard.classList.remove("activeDashboard");
            billingDashboard.classList.add("inactiveDashboard");
        } else {
            billingDashboard.classList.add("inactiveDashboard");
        }

        if (billingDashboardInvoices.classList.value.includes("inactiveInvoicesSlider")) {
            billingDashboardInvoices.classList.remove("inactiveInvoicesSlider");
            billingDashboardInvoices.classList.add("activeInvoicesSlider");
        } else if (billingDashboardInvoices.classList.value.includes("activeInvoicesSlider")) {
            billingDashboardInvoices.classList.remove("activeInvoicesSlider");
            billingDashboardInvoices.classList.add("inactiveInvoicesSlider");
        } else {
            billingDashboardInvoices.classList.add("activeInvoicesSlider");
        }
    }

    toggleCurrencyStatistics(currencyStatisticsInfo, statisticsInformationRow) {
        const table = document.querySelector(`.${statisticsInformationRow}`)
        const icon = table.querySelector('i');
        const item = document.querySelector(`.${currencyStatisticsInfo}`);

        if (![...table.classList].includes('activeStatisticsInformationRow') ) {
            table.classList.add('activeStatisticsInformationRow');
            icon.textContent = 'do_not_disturb_on';
            item.style.display = 'flex';
            item.style.justifyContent = 'space-between';
            table.style.borderBottom = '';
        } else {
            table.classList.remove('activeStatisticsInformationRow');
            icon.textContent = 'add_circle';
            item.style.display = 'none';
            table.style.borderBottom = '1px solid rgb(222, 226, 230)';
        }
    }

    toggleRevenueButtons(button) {
        
        this.setState(
            () => ({
              isWeeklyRevenue: button === 'weekly' ? true : false,
              isMonthlyRevenue: button === 'monthly' ? true : false,
              isInvoicesSearch: button === 'invoices' ? true : false,
            }), () => {
            if(this.state.isMonthlyRevenue) {
                this.props.getMonthlySystemStatisticDashboard(this.state.monthlyCurrentPageNumber, this.state.monthlySearchQuery);
            } else if(this.state.isWeeklyRevenue) {
                this.props.getSystemStatisticDashboard(this.state.currentPageNumber, this.state.searchQuery)
            } else if (this.state.isInvoicesSearch) {
                this.props.getDataBasedOnInvoiceNumberSearch(this.state.invoicesCurrentPage, this.state.searchQuery)
            }
        })

        this.removeActiveCurrencyInfo()
    }

    toggleRevolutInfoTooltip(targetName) {
        
        if (!this.state[targetName]) {
              this.setState({
                ...this.state,
                [targetName]: {
                  tooltipOpen: true
                }
              });
        } else {
              this.setState({
                ...this.state,
                [targetName]: {
                  tooltipOpen: !this.state[targetName].tooltipOpen
                }
              });
          };
    }

    isToolTipOpen (targetName) {
        return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
    };
    

    renderWeeklyAndMonthlyRevenueButtons() {
        const { revenueButtonsStyle, activeRevenueButtonStyle } = styles;
        const { isWeeklyRevenue, isMonthlyRevenue, isInvoicesSearch } = this.state;

        return (
            <div style={{borderBottom: '1px solid #dee2e6', marginBottom: '20px', display: 'flex'}}>
                <div style={isWeeklyRevenue ? {...revenueButtonsStyle, ...activeRevenueButtonStyle} : revenueButtonsStyle} onClick={() => this.toggleRevenueButtons('weekly')}>
                    {i18n.t('screens:paymentScreen.weeklyRevenue')}
                </div>
                <div style={isMonthlyRevenue ? {...revenueButtonsStyle, ...activeRevenueButtonStyle} : revenueButtonsStyle} onClick={() => this.toggleRevenueButtons('monthly')}>
                    {i18n.t('screens:paymentScreen.monthlyRevenue')}
                </div>
                <div style={isInvoicesSearch ? {...revenueButtonsStyle, ...activeRevenueButtonStyle} : revenueButtonsStyle} onClick={() => this.toggleRevenueButtons('invoices')}>
                    {i18n.t('screens:paymentScreen.invoices')}
                </div>
            </div>
        )
    }

    renderDownloadRevolutFileButton = (week, year, index) => {
        
        return (
            <div id={`btn-${index}`}>
                <Button disabled={this.state.isMonthlyRevenue} onClick={() => this.props.downloadRevolutFile(week, year)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>
                        <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                    </span>
                    {i18n.t('screens:paymentScreen.revolut')}
                </Button>
                {
                    this.state.isMonthlyRevenue ?
                        <Tooltip disabled={false} placement="top" isOpen={this.isToolTipOpen(`btn-${index}`)} target={`btn-${index}`} toggle={() => this.toggleRevolutInfoTooltip(`btn-${index}`)}>
                            {i18n.t('screens:paymentScreen.revolutInfo')}
                        </Tooltip> : null
                }
            </div>
        )
    }

    renderDownloadSimpleRestaurantsFileButton = (week, year, month) => {
        // Billing Type 1 is for Simple Billing Restaurants
        const billingType = 1;

        return (
            <Button onClick={() => this.props.downloadAccountingFiles(week, year, month, billingType)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '5px' }}>
                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                </span>
                {i18n.t('screens:paymentScreen.simpleRestaurants')}
            </Button>
        )
    }

    renderDownloadAdvancedRestaurantsFileButton = (week, year, month) => {
        // Billing Type 2 is for Advanced Billing Restaurants
        const billingType = 2;
        
        return (
            <Button onClick={() => this.props.downloadAccountingFiles(week, year, month, billingType)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '5px' }}>
                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                </span>
                {i18n.t('screens:paymentScreen.advancedRestaurants')}
            </Button>
        )
    }

    renderDownloadXeroFileButton = (week, year, month) => {
        
        return (
            <Button onClick={() => this.props.downloadXeroFile(week, year, month)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '5px' }}>
                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                </span>
                {i18n.t('screens:paymentScreen.xero')}
            </Button>
        )
    }

    renderDateButton = (week, year, currencyStatisticsInfo, statisticsInformationRow, month) => {
        const { billingInvoiceInformationButtonStyle } = styles;

        return (
            <div style={{display: 'flex'}}>
                <Button xs={1}  outline="false" onClick={() => this.toggleCurrencyStatistics(currencyStatisticsInfo, statisticsInformationRow)}  style={billingInvoiceInformationButtonStyle}>
                    <MaterialIcon icon='add_circle' color="#0288D1" size={19} style={{paddingLeft: '0px'}}/>
                </Button>
                {
                    this.state.isWeeklyRevenue ?
                    <Button color="link" onClick={() => this.props.getInvoiceCollection(0, week, year, null, () => {
                        this.setState({
                            ...this.state,
                            currentInvoiceCollectionDate: {
                                week: week,
                                year: year
                            }
                        }, () => {
                            this.toggleInvoicesDashboard()
                        })
                    })}>
                        {`${week} / ${year}`}
                    </Button> :
                    <Button color="link" onClick={() => this.props.getMonthlyPayableReconciliation(0, month, year, null, null, () => {
                        this.setState({
                            ...this.state,
                            currentMonthPayableReconDate: {
                                month: month,
                                year: year
                            }
                        }, () => {
                            this.toggleInvoicesDashboard()
                        })
                    })}>
                        {`${month} / ${year}`}
                    </Button>
                }
                
            </div>
        )
    }

    renderDownloadButton = (restaurantId, week, year, month, invoiceNumber) => {

        return (
            <Button color="link" onClick={() => this.props.downloadInvoice(restaurantId, week, year, month, invoiceNumber)} style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '5px' }}>
                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                </span>
                {i18n.t('screens:eventTrackingScreen.download')}
            </Button>
        )
    }

    renderPagination() {
        const { flexEnd } = styles;
        const { systemStatistic } = this.props;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={systemStatistic.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={systemStatistic.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    renderMonthlyPagination() {
        const { flexEnd } = styles;
        const { monthlySystemStatistic } = this.props;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={monthlySystemStatistic.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={monthlySystemStatistic.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handleMonthlyPageChange}
                />
            </Col>
        );
    }

    renderInvoicesPagination() {
        const { flexEnd } = styles;
        const { invoiceDataCollection } = this.props.invoices;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={invoiceDataCollection.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={invoiceDataCollection.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handleInvoicesPageChange}
                />
            </Col>
        );
    }

    renderSearch() {
        const { week, year, month, billingTypeIndex } = this.state.isWeeklyRevenue ? this.state.searchQuery : this.state.monthlySearchQuery;
        const { paddingLeftRight } = styles;

        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }} xs="auto" sm={12} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col hidden={this.state.isMonthlyRevenue || this.state.isInvoicesSearch} style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="week" 
                            id="week" 
                            placeholder={i18n.t('screens:paymentScreen.week')} 
                            value={week} 
                            onChange={this.changeState}
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)} 
                            />
                        </Col>
                        <Col hidden={this.state.isInvoicesSearch} style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="month" 
                            id="month" 
                            placeholder={i18n.t('screens:paymentScreen.month')} 
                            value={month} 
                            onChange={this.changeState} 
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                            />
                        </Col>
                        <Col hidden={this.state.isInvoicesSearch} style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="year" 
                            id="year" 
                            placeholder={i18n.t('screens:paymentScreen.year')} 
                            value={year} 
                            onChange={this.changeState} 
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)}
                            />
                        </Col>
                        <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '15px' }}>
                            <SearchButton search={this.search} />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}
                                >
                                    {i18n.t('common:searchForms.clear')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <div style={{position: 'absolute', top: '52px', maxWidth: this.state.isWeeklyRevenue ? '500px' : '350px', fontSize: '13px'}}>
                    {this.state.isWeeklyRevenue ? i18n.t('screens:paymentScreen.weeklySearchInfo') : this.state.isMonthlyRevenue ? i18n.t('screens:paymentScreen.monthlySearchInfo') : null}
                </div>
            </Col>
        )
    }

    renderTable() {
        const { systemStatistic } = this.props;
        const { headerContainer, headerContainerCurrency } = styles;

        return (
            <Col style={{ padding: '0px' }}>
                <Row style={{...headerContainer, backgroundColor: '#f8f8f8', padding: '10px 0', borderBottom: 'none'}}>
                    <Col xs={11} style={{padding: '0px'}}>
                        <div style={headerContainerCurrency}>
                            <Col xs={1}>{this.state.isWeeklyRevenue ? i18n.t('screens:paymentScreen.week') : i18n.t('screens:paymentScreen.month')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.count')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.orderTotal')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.cashTotal')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.cardTotal')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.averageOrder')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.simpleTotal')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.advancedTotal')} </Col>
                            <Col xs={1}>{i18n.t('screens:paymentScreen.total')} </Col>
                        </div>
                    </Col>
                    <Col xs={1} style={{ display: 'flex', justifyContent: 'center'}}>
                        {i18n.t('screens:paymentScreen.files')}
                    </Col>
                </Row>
                {
                    systemStatistic.content && systemStatistic.content.length ?
                        this.renderTableRows() :
                        <Col style={{ width: '90%', padding: '15px 15px 0', borderBottom: '1px solid #dee2e6' }}>
                            <p style={{ fontSize: '14px' }}>{i18n.t('screens:centralOrdersLog.noResults')}</p>
                        </Col>
                }
                {/* <Col style={{ paddingRight: '0px' }}>{this.state.isWeeklyRevenue ? this.renderPagination() : this.renderMonthlyPagination()}</Col> */}
                <Col style={{ paddingRight: '0px' }}>{this.state.isWeeklyRevenue ? this.renderPagination() : this.state.isInvoicesSearch ? this.renderInvoicesPagination() : this.renderMonthlyPagination()}</Col>
            </Col>
        );
    }

    renderTableRows() {

        const { headerContainer, headerContainerCurrency, headerContainerInfo } = styles;
        const { systemStatistic, monthlySystemStatistic } = this.props;
        const { isWeeklyRevenue, isMonthlyRevenue } = this.state;

        const content = systemStatistic.content && isWeeklyRevenue ? systemStatistic.content : monthlySystemStatistic.content && isMonthlyRevenue ? monthlySystemStatistic.content : null;

        if (content !== undefined && content !== null && content.length) {
            return content.map((statistic, i) => {
                const currencyStatisticsInfo = `currencyStatisticsInfo${i}`;
                const statisticsInformationRow = `statisticsInformationRow${i}`;
                const renderStatisticWeekOrMonth = isWeeklyRevenue ? statistic.week : statistic.month;
                const isWeek = isWeeklyRevenue ? statistic.week : null;
                const isMonth = isMonthlyRevenue ? statistic.month : null;

                return (
                    <div>
                        <Row key={i} style={headerContainer} className={statisticsInformationRow}>
                            <Col xs={11} style={{padding: '0px'}}>
                                <div style={headerContainerCurrency}>
                                    <Col xs={1}>{this.renderDateButton(renderStatisticWeekOrMonth, statistic.year, currencyStatisticsInfo, statisticsInformationRow, statistic.month)}</Col>
                                    <Col xs={1}>{(Number(statistic.count))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.orderTotal))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.cashTotal))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.cardTotal))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.averageOrder))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.simpleTotal))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.advancedTotal))}</Col>
                                    <Col xs={1}>{transformProductPrice(Number(statistic.total))}</Col>
                                </div>
                            </Col>
                            <Col xs={1} style={{ display: 'flex', justifyContent: 'start' }}>
                                {this.renderDownloadRevolutFileButton(statistic.week, statistic.year, i)}
                            </Col>
                        </Row>
                        <Row style={{...headerContainerInfo, display: 'none'}} className={currencyStatisticsInfo}>
                            <Col xs={11} style={{padding: '0px'}}>
                                {this.renderCurrencyStatistics(statistic.currencyRevenues)}
                            </Col>
                            <Col xs={1} style={{display: 'flex', flexDirection: 'column', justifyContent: 'start'}}>
                                {this.renderDownloadSimpleRestaurantsFileButton(isWeek, statistic.year, isMonth)}
                                {this.renderDownloadAdvancedRestaurantsFileButton(isWeek, statistic.year, isMonth)}
                                {this.renderDownloadXeroFileButton(isWeek, statistic.year, isMonth)}
                                
                            </Col>
                        </Row>
                    </div>
                )
            })
        }
    }

    renderInvoiceSearchTable() {
        const { headerContainer, headerContainerCurrency } = styles;

        return (
            <Col style={{ padding: '0px' }}>
                <Row style={{...headerContainer, backgroundColor: '#f8f8f8', padding: '10px 0', borderBottom: 'none'}}>
                    <div style={headerContainerCurrency}>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.invoiceNumber')} </Col>
                        <Col xs={2}>{i18n.t('screens:generalScreen.restaurantName')} </Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.fromDate')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.toDate')}</Col>
                        <Col xs={1}>{i18n.t('screens:paymentScreen.total')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.transferTotal')}</Col>
                        <Col xs={1}>{i18n.t('common:buttons.download')}</Col>
                    </div>
                </Row>
                {this.renderInvoicesSearchTableRows()}
                <Col style={{ paddingRight: '0px' }}>{this.renderInvoicesPagination()}</Col>
            </Col>
        )
    }

    renderInvoicesSearchTableRows() {
        const { headerContainer } = styles;
        const { invoiceDataCollection } = this.props.invoices;
        const content = invoiceDataCollection.content ? invoiceDataCollection.content : null;

        if (content !== undefined && content !== null && content.length) {
            return content.map((order, i) => {
                return (
                    <Row key={i} style={headerContainer}>
                        <Col xs={2}>{order.invoiceNumber}</Col>
                        <Col xs={2}>{order.restaurantName}</Col>
                        <Col xs={2}>{order.fromDate}</Col>
                        <Col xs={2}>{order.toDate}</Col>
                        <Col xs={1}><span>{transformProductPrice(Number(order.total))}</span><span>{getCurrencySymbol(this.props.restaurant.currency)}</span></Col>
                        <Col xs={2}>{order.transferTotal ? <span>{transformProductPrice(Number(order.transferTotal))} {getCurrencySymbol(this.props.restaurant.currency)}</span> : '-'}</Col>
                        <Col xs={1} style={{ display: 'flex', justifyContent: 'center' }}>{this.renderDownloadButton(order.restaurantId, order.week, order.month, order.year, order.invoiceNumber)}</Col>
                    </Row>
                )
            })
        }
    }

    renderInvoiceSearch() {
        const { paddingLeftRight } = styles;

        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }} xs="auto" sm={12} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row>
                        <Col style={paddingLeftRight}>
                            <Input 
                            type="number" 
                            name="invoiceNumber" 
                            id="invoiceNumber" 
                            placeholder={i18n.t('screens:paymentScreen.invoiceNumber')} 
                            value={this.state.invoiceNumber} 
                            onChange={this.changeState}
                            onKeyPress={(e) => this.negativeDecimalsValidation(e)} 
                            />
                        </Col>
                    <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '15px' }}>
                        <SearchButton search={this.search} />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}
                                >
                                    {i18n.t('common:searchForms.clear')}
                            </Button>
                    </Col>
                </Row>
            </Form>
        </Col>
        )
    }

    renderCurrencyStatistics (currencyRevenues) {

        return currencyRevenues.map((currencyStatistic, i) => {
            const { headerContainerCurrency } = styles;
            const badgeWidth = '50px';
        
            if (currencyRevenues !== undefined && currencyRevenues !== null && currencyRevenues.length) {
                return(
                    <div key={i} style={headerContainerCurrency} className='statisticsInformationRow'>
                        <Col xs={1} style={{display: 'flex', alignItems: 'baseline', justifyContent: 'space-between'}}>
                            <span style={{display: 'flex', alignItems: 'baseline'}} className='statisticsInformationItem'>
                                <Badge color="primary" style={{ width: currencyStatistic.currency.length > 5 ? '' : badgeWidth}}>&nbsp;{currencyStatistic.currency.toUpperCase()}&nbsp;</Badge>&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        </Col>
                        <Col xs={1}>{(Number(currencyStatistic.count))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.orderTotal))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.cashTotal))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.cardTotal))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.averageOrder))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.simpleTotal))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.advancedTotal))}</Col>
                        <Col xs={1}>{transformProductPrice(Number(currencyStatistic.total))}</Col>
                        {/* <Col xs={1}></Col> */}
                    </div>
                )
            }
        })
    }


    render() {
        // const { isInvoicesDashboardOpen } = this.state;
        const { isWeeklyRevenue, isMonthlyRevenue, isInvoicesSearch } = this.state;
        
        return (
            <div style={{padding: '15px', position: 'relative', maxWidth: '95%', margin: '0 auto', marginTop: '20px'}}>
                <div id='billingDashboard' className='billingDashboard'>
                        <Row style={{paddingLeft: '10px'}}>{this.renderWeeklyAndMonthlyRevenueButtons()}</Row>
                        <Row>{isWeeklyRevenue || isMonthlyRevenue ? this.renderSearch() : isInvoicesSearch ? this.renderInvoiceSearch() : null}</Row>
                        <Row>{isWeeklyRevenue || isMonthlyRevenue ? this.renderTable() : isInvoicesSearch ? this.renderInvoiceSearchTable() : null}</Row>
                </div>
                <div id='billingDashboardInvoices' className='billingDashboardInvoices'>
                    <BillingDashboardInvoiceCollection 
                    toggleInvoicesDashboard={this.toggleInvoicesDashboard}
                    styles={this.props.styles}
                    restaurantNames={this.props.restaurantNames}
                    ordersLog={this.props.ordersLog}
                    invoiceCollection={this.state.currentInvoiceCollection}
                    invoiceCollectionDate={this.state.currentInvoiceCollectionDate}
                    monthlyPayableRecon={this.props.monthlyPayableRecon}
                    monthlyPayableReconDate={this.state.currentMonthPayableReconDate}
                    onBackInvoiceCollection={this.onBackInvoiceCollection}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {

    return {
        restaurant: state.restaurant,
        restaurantNames: state.ordersLog.restaurantNames,
        ordersLog: state.ordersLog,
        systemStatistic: state.billingDashboard.systemStatistic,
        invoiceCollection: state.billingDashboard.invoiceCollection,
        monthlySystemStatistic: state.billingDashboard.monthlySystemStatistic,
        monthlyPayableRecon: state.billingDashboard.monthlyPayableRecon,
        invoices: state.invoiceDataCollection
    }
};

export default connect(mapStateToProps, {
    getSystemStatisticDashboard, 
    getInvoiceCollection, 
    downloadRevolutFile,
    getBrandAndRestNames,
    downloadAccountingFiles,
    getMonthlySystemStatisticDashboard,
    downloadXeroFile,
    getMonthlyPayableReconciliation,
    getDataBasedOnInvoiceNumberSearch,
    downloadInvoice
})(BillingDashboard);

let styles = {
    headerContainer: {
        width: '100%',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        padding: '5px 0',
        borderBottom: '1px solid #dee2e6'
    },
    paddingLeftRight: {
        maxWidth: '180px',
        paddingLeft: 5,
        paddingRight: 0,
        marginBottom: 5
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    },
    billingInvoiceInformationButtonStyle: {
        backgroundColor: 'white', 
        border: 'none', 
        paddingRight: '0px',
        paddingLeft: '0px',
        boxShadow: 'none'
    },
    headerContainerCurrency: {
        width: '100%',
        maxWidth: '100%',
        //margin: '0px 0px 5px 0px',
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        //padding: '5px 0',
    },
    revenueButtonsStyle: {
        cursor: 'pointer',
        padding: '3px',
        fontSize: '15px',
        marginRight: '10px'
    },
    activeRevenueButtonStyle: {
        color: '#0288d1',
        borderBottom: '2px solid #0288d1'
    },
    headerContainerInfo: {
        width: '100%',
        margin: 0,
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        padding: '5px 0',
        borderBottom: '1px solid #dee2e6'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/BillingDashboard.js